import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import bannerImage from '../assets/banner.jpg';

const Banner = ({ onGoToServicios, onGoToContacto }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: { xs: '60vh', md: '70vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',              // 👈 centra el contenido en el eje X
        color: '#ffffff',
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay oscuro */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(120deg, rgba(0,0,0,0.8), rgba(0,0,0,0.3))',
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 1,
          py: { xs: 8, md: 10 },
        }}
      >
        <Stack
          spacing={3}
          sx={{
            maxWidth: 560,
            mx: 'auto',                       // 👈 centra el bloque
            textAlign: 'center',              // 👈 texto centrado
            alignItems: 'center',             // 👈 alinea hijos al centro (botones incluidos)
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Outfit, var(--title-font)',
              fontSize: { xs: 14, sm: 16 },
              letterSpacing: 6,
            }}
          >
            PRODUCCIÓN AUDIOVISUAL PROFESIONAL
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontFamily: 'Outfit, var(--title-font)',
              fontWeight: 700,
              fontSize: { xs: 32, sm: 40, md: 48 },
              lineHeight: 1.1,
            }}
          >
            D3 Producciones
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Poppins, var(--text-font)',
              fontSize: { xs: 14, sm: 15 },
              lineHeight: 1.8,
              maxWidth: 520,
            }}
          >
            Video, fotografía, streaming y soluciones audiovisuales para que tus
            eventos y tu marca se vean tan profesionales como suenan.
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            sx={{
              mt: 1,
              width: '100%',
              justifyContent: 'center',       // 👈 centra botones en fila
              alignItems: 'center',           // 👈 y también en columna
            }}
          >
            <Button
              onClick={onGoToServicios}
              sx={{
                flex: { xs: 1, sm: 'none' },
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 15,
                borderRadius: '4px',
                px: 3,
                py: 1.1,
                backgroundColor: '#3c77b6',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#315f94',
                },
              }}
            >
              VER SERVICIOS
            </Button>
            <Button
              onClick={onGoToContacto}
              sx={{
                flex: { xs: 1, sm: 'none' },
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 15,
                borderRadius: '4px',
                px: 3,
                py: 1.1,
                border: '1px solid rgba(255,255,255,0.8)',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.08)',
                },
              }}
            >
              CONTACTO
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Banner;
